import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=4b3c4664&"
import script from "./ClientView.vue?vue&type=script&lang=js&"
export * from "./ClientView.vue?vue&type=script&lang=js&"
import style0 from "./ClientView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports